import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactHighcharts from '../CommonComponents/Highcharts';
import LoadingChart from '../CommonComponents/LoadingChart';
import { createCustomPropType, isNumeric, isUuid } from '../../js/app/react/validators';

export default class MobileRetirementAssetsChartView extends Component {
  constructor(props) {
    super(props);
    this.load = this.load.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.load(this.props);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (
      newProps.fpId !== this.props.fpId ||
      newProps.clientId !== this.props.clientId ||
      newProps.data !== this.props.data
    ) {
      this.load(newProps, true);
    }
  }

  shouldComponentUpdate(newProps) {
    if (newProps.fpId === this.props.fpId && newProps.clientId === this.props.clientId) {
      if (!window.ADV.util.shallowEqual(newProps.chartData, this.props.chartData)) {
        return true;
      }
      if (newProps.showLoading !== this.props.showLoading) {
        return true;
      }
      if (newProps.proposedPlanName !== this.props.proposedPlanName) {
        return true;
      }
      return false;
    }
    return true;
  }

  // eslint-disable-next-line class-methods-use-this
  load({ fpId, clientId, fetchData, receiveData, data }, showLoading) {
    if (data) {
      receiveData(
        {
          GoalChart: {
            Chart: data,
          },
        },
        clientId,
      );
    } else {
      fetchData(fpId, clientId, showLoading);
    }
  }

  render() {
    const { chartData, loading, showLoading } = this.props;

    let Content = null;
    if (!chartData && !loading) {
      return null;
    }

    if (showLoading) {
      Content = <LoadingChart />;
    } else if (chartData) {
      Content = (
        <ReactHighcharts
          autoResize
          container="RetirementAssetsChartContainer"
          options={chartData}
        />
      );
    } else {
      Content = <LoadingChart />;
    }

    return <section className="RetirementAssetsChart mobile">{Content}</section>;
  }
}

MobileRetirementAssetsChartView.propTypes = {
  showLoading: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  fpId: createCustomPropType(isUuid).isRequired,
  data: PropTypes.shape({}).isRequired,
  chartData: PropTypes.shape({}).isRequired,
  proposedPlanName: PropTypes.string.isRequired,
};
